var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"login"},[_vm._t("default"),_c('footer',[_vm._v("Powered by DAS LOKET SOCIAL")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }